import { ErrorBoundary } from '@sentry/react'
import { Suspense, lazy } from 'react'
import { Outlet } from 'react-router-dom'

import WorkspaceStatus from '~/features/workspaces/WorkspaceStatus.tsx'

import Banners from './components/Banners/index.tsx'
import Header from './components/Header/index.tsx'
import { Sidebar } from './components/Sidebar.tsx'
import { LayoutError, MainError } from './LayoutError.tsx'
import { Spinner } from '../Loading/index.tsx'

const StripeProvider = lazy(() => import('../StripeProvider.tsx'))

// We share the header with the legacy non-c (cakephp-generated) pages.
function Layout() {
  return (
    <ErrorBoundary
      fallback={LayoutError}
      beforeCapture={(scope) => {
        scope.setTag('location', 'App')
      }}
    >
      <Banners aboveHeader />
      <Header />

      <div className="tl-container tl-container--main">
        <Sidebar />

        <div className="content">
          <Banners />

          <ErrorBoundary
            fallback={MainError}
            beforeCapture={(scope) => {
              scope.setTag('location', 'App/Content')
            }}
          >
            <Suspense fallback={<Spinner className="loading--page" />}>
              <StripeProvider>
                <WorkspaceStatus>
                  <Outlet />
                </WorkspaceStatus>
              </StripeProvider>
            </Suspense>
          </ErrorBoundary>
        </div>
      </div>
    </ErrorBoundary>
  )
}

export { Layout as Component }
